import logo from './logo.svg';
import './App.css';
import SideBar from './components/SideBar';
import Section from './components/Section';

function App() {
  return (
    <div className='App'>
      <SideBar />
      <Section />
    </div>
  );
}

export default App;
